if (!customElements.get('announcement-rotator')) {
  customElements.define(
    'announcement-rotator',
    class AnnouncementRotator extends HTMLElement {
      connectedCallback() {
        this.messages = Array.from(this.querySelectorAll('.announcement-bar__message'));
        if (this.messages.length < 2) return;
        this.index = 0;
        this.interval = Number(this.dataset.interval) || 5000;
        this.paused = false;
        ['mouseenter', 'focusin'].forEach((e) => this.addEventListener(e, () => (this.paused = true)));
        ['mouseleave', 'focusout'].forEach((e) => this.addEventListener(e, () => (this.paused = false)));
        document.addEventListener('shopify:block:select', (event) => {
          const i = this.messages.indexOf(event.target);
          if (i > -1) {
            this.paused = true;
            this.show(i);
          }
        });
        document.addEventListener('shopify:block:deselect', () => (this.paused = false));
        if (window.theme && window.theme.prefersReducedMotion()) return;
        this.timer = setInterval(() => {
          if (!this.paused && !document.hidden) this.show((this.index + 1) % this.messages.length);
        }, this.interval);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      show(index) {
        this.messages.forEach((message, i) => {
          const active = i === index;
          message.classList.toggle('is-active', active);
          message.toggleAttribute('aria-hidden', !active);
          message.querySelectorAll('a').forEach((a) => (active ? a.removeAttribute('tabindex') : a.setAttribute('tabindex', '-1')));
        });
        this.index = index;
      }
    }
  );
}
